export const setMockFormData = (setFormData) => {
  setFormData({
    // Tour Concept (TourObjectives.js)
    tourName: 'Global Domination Tour',
    artistName: 'The Cosmic Keys',
    genre: 'Psychedelic Rock',
    tourScale: 'large', // Corresponds to 'Large' or 'Stadium/Festival'
    tourConcept: 'A journey through sound and space, exploring new dimensions of music.',
    tourObjectives: ['promote-album', 'revenue', 'fanbase'],
    audienceAge: '18-35',
    fanbaseSize: 'major', // corresponds to '250K-1M fans'
    audienceDescription: 'Fans of classic rock with a modern twist, festival-goers, and music enthusiasts.',
    careerStage: 'established',
    releaseStatus: 'supporting-release',
    tourExperience: 'international',

    // Objectives & Audience (ObjectivesAudience.js)
    objectives: ['generate-revenue', 'build-audience', 'engagement'],
    customObjective: '',
    metrics: ['attendance', 'revenue', 'social-engagement'],
    customMetric: '',
    audienceInterests: ['Rock music', 'Festivals', 'Vinyl collectors', 'Live music enthusiasts'],
    ageRangeMin: '18',
    ageRangeMax: '45',
    geographicFocus: 'international',
    audienceSize: 'very-large',
    additionalContext: 'Strong presence on streaming platforms with viral potential for content.',

    // Scope & Timeline (ScopeTimeline.js)
    tourDuration: '6',
    tourDurationUnit: 'months',
    startDate: '2025-10-01',
    endDate: '2026-04-01',
    dateFlexibility: '10', // Numeric value for a slider
    seasonPreferences: ['spring', 'fall'],
    targetRegions: ['north-america', 'europe', 'australia-oceania'],
    specificCities: ['New York', 'London', 'Sydney', 'Berlin'],
    regionsToAvoid: ['Antarctica'],
    routingStrategy: 'sequential',
    travelDayConsideration: 'dedicated-travel',
    clusteredRouting: true,
    prioritizeWeekends: true,
    daysOffPerWeek: '2',
    maxConsecutiveShows: '5',
    extendedBreaks: true,
    extendedBreakLength: '7',
    extendedBreakFrequency: '6',
    timelineNotes: 'Consider local holidays and major sporting events when routing.',
    eventsPerWeek: '4',

    // Budget (BudgetParameters.js)
    budgetMin: '500000',
    budgetMax: '1000000',
    budgetFlexibility: '15', // Numeric value for a slider
    budgetPriorities: { 
      'venue': 1, 
      'technical': 2, 
      'marketing': 3, 
      'transportation': 4, 
      'accommodations': 5, 
      'talent': 6, 
      'staff': 7, 
      'hospitality': 8 
    },
    revenueSources: ['ticket-sales', 'merchandise', 'sponsorships'],
    customRevenueSource: '',
    revenueTarget: '75000',
    breakEvenRequirement: 'yes', // 'yes'/'no'
    maxPerEventBudget: '50000',
    maxVenueCost: '15000',
    maxPerPersonCost: '100',
    costLimitations: 'Keep travel costs under 20% of total budget.',
    additionalBudgetNotes: 'Prioritize production quality over luxury accommodations.',

    // Venue & Technical (VenueTechnical.js)
    venueTypes: ['performance-venues', 'outdoor-spaces'],
    minCapacity: '1000',
    maxCapacity: '5000',
    seatingStyles: ['theater', 'standing'],
    mainSpaceSize: '5000',
    mainSpaceSizeUnit: 'sq ft',
    additionalSpaces: ['green-room', 'backstage', 'storage'],
    venueAmenities: ['accessibility', 'public-transport', 'alcohol-service'],
    venueExclusions: 'No venues with poor sound reviews.',
    technical_sound: 'Professional PA system, 32-channel mixer, stage monitors.',
    technical_lighting: 'Dynamic lighting rig, haze machines, laser effects.',
    technical_stage: 'Minimum 40x30 ft stage, risers for drums and keys.',
    technical_video: 'Large LED screen backdrop, live camera feed capabilities.',
    technical_internet: 'High-speed internet for streaming and crew communication.',
    technical_power: 'Sufficient power drops for all equipment, backup generator preferred.',
    technical_other: 'Backstage green rooms, secure storage for equipment.',

    // Logistics (LogisticsTransportation.js)
    transportationTypes: ['air', 'bus', 'cargo'],
    transportationOther: '',
    coreTeamSize: '10',
    additionalPersonnel: '5',
    equipmentVolume: 'substantial', // 'minimal', 'moderate', 'substantial', 'extensive'
    specialHandlingEquipment: 'Vintage synthesizers, custom-built guitar rigs.',
    oversizedItems: 'Drum kit, large speaker cabinets.',
    fragileItems: 'Guitars, vintage keyboards.',
    transportationPermits: 'Carnets for international equipment transport.',
    standardRooms: '10',
    upgradeRooms: '2',
    specialRoomRequirements: 'Quiet rooms for artists, non-smoking.',
    accommodationLevel: '70', // Slider value
    venueDistance: '30',
    venueDistanceUnit: 'minutes',
    specialLogistics: 'Coordinate with local customs for equipment clearance.',

    // Marketing (MarketingPromotion.js)
    marketingStartDate: '2025-06-01',
    announcementDate: '2025-07-01',
    ticketLaunchDate: '2025-07-15',
    marketingChannels: ['email', 'social', 'radio', 'pr'],
    channelRatings: { 
      'email': 4, 
      'social': 5, 
      'radio': 3, 
      'pr': 4 
    },
    socialPlatforms: ['instagram', 'tiktok', 'facebook', 'twitter'],
    socialPlatformsOther: '',
    socialFollowers: '1000000',
    emailSubscribers: '250000',
    promotionalAssets: ['photos', 'video', 'press', 'website'],
    promotionalAssetsOther: '',
    localAdBudget: '5000',
    localPartnerships: true,
    mediaAppearances: true,
    promoEvents: true,
    promoEventsDetails: 'Acoustic sets at local radio stations, meet & greets.',
    additionalMarketingNotes: 'Focus on engaging content and fan interactions.',

    // Personnel (PersonnelStaffing.js)
    keyStaff: [
      { role: 'tour-manager', roleLabel: 'Tour Manager', count: 1 },
      { role: 'sound-engineer', roleLabel: 'Sound Engineer', count: 2 },
      { role: 'lighting-tech', roleLabel: 'Lighting Technician', count: 1 },
      { role: 'security', roleLabel: 'Security Personnel', count: 4 }
    ],
    customRoleLabel: '',
    hiringSources: ['existing', 'travel', 'agency'],
    specializedSkills: 'Experience with large-scale rock productions.',
    requiredCertifications: ['first-aid', 'security'],
    otherCertification: 'Pyrotechnics license (if applicable)',
    preTourTraining: 'Safety briefings, emergency protocols.',
    managementStructure: 'hierarchical',
    dailyBriefings: true,
    digitalPlatform: true,
    digitalPlatformName: 'TourSleek',
    staffMeetings: true,
    additionalPersonnelNotes: 'Local crew to be hired in each city for load-in/out.',
    
    // Compliance & Risk (ComplianceRisk.js)
    insuranceNeeds: ['liability', 'cancellation', 'equipment', 'travel'],
    insuranceOther: '',
    permitsNeeded: ['event', 'sound', 'alcohol'],
    permitOther: '',
    hasEmergencyPlan: true,
    emergencyPlanDetails: 'Comprehensive plan addressing medical emergencies, venue evacuation, and natural disasters.',
    hasSecurityRequirements: true,
    securityRequirements: 'Minimum of 4 security personnel at all venues, background checks required.',
    complianceNotes: 'All venues must meet fire safety code regulations and provide necessary permits.',
    
    // Special Requirements (SpecialRequirements.js)
    hasVipNeeds: true,
    vipNeedsDetails: 'Private backstage area with separate entrance, premium catering.',
    specialGuestRequirements: 'Green room for opening acts, separate areas for media.',
    dietaryNeeds: ['vegetarian', 'gluten-free', 'vegan'],
    cateringNotes: 'Organic and locally-sourced food where possible. Bottled water required backstage.',
    accessibilityNeeds: ['wheelchair', 'hearing'],
    accessibilityNotes: 'All venues must provide wheelchair access to stage and backstage areas.',
    otherSpecialRequirements: 'Temperature-controlled storage for instruments, quiet area for pre-show preparation.',
    
    // Data Collection (DataCollection.js)
    dataSources: ['web-search', 'social-trends', 'event-analytics', 'demographic-data'],
    customDataFile: 'previous_tour_stats.xlsx',
    customDataDescription: 'Detailed attendance and merchandise sales from previous tour.',
    dataPriority: 'balanced',
    analysisDepth: 4,
    dataAnalysisNotes: 'Focus on analyzing attendance patterns by demographic and region.',

    additionalNotes: 'This is a major comeback tour, aiming for high impact and media coverage. Sustainability efforts should be considered where possible.'
  });
};
